<template>
  <div class="footer">
    <div class="content has-text-centered">
      <p>
        <strong>Thwack Tracker</strong> by <a href="https://curren.me">Mike Curren</a>
        <!-- . Made with <a href="https://vuejs.org/">Vue</a>. -->
      </p>
    </div>
  </div>
</template>
<script>
export default {
  name: 'Footer',
  data () {
    return {
    }
  },
}
</script>
<style scoped>
footer {
  display: flex;
  flex-direction: column;
  justify-content: flex-end;
}
.footer {
  /* border: 5px solid #333333; */
  /* border-radius: 1.5em; */
  color: #121212;
  background-color: #CC0066;
  background-image: url(/static/footer-tongue.svg);
  background-repeat: no-repeat;
  background-position: bottom center;
  /* background-size: auto; */
  padding: 20px 2em 3em;
  /* margin: 0 1.5em 1em; */
  margin-top: 3em;
}
.footer:before {
  display: block;
  content: '';
  background-image: url(/static/footer-teeth.svg);
  background-repeat: repeat-x;
  background-position: top center;
  background-size: auto;
  width: calc(100% + 64px);
  height: 20px;
  margin: -40px -32px 0;
}
.footer > .content {
  padding-top: 2em;
}
.footer a {
  color: #FCF6C3;
}
.footer strong {
  color: inherit;
}
/* @media (max-width: 900px) and (orientation: landscape) {
  .footer {
    display: none;
  }
} */
</style>


// WEBPACK FOOTER //
// src/components/InfoFooter.vue